"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailHeaderModule = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var LeftRailHeader_1 = require("./LeftRailHeader");
exports.LeftRailHeaderModule = mobx_react_1.inject('globalStore')(function (props) {
    if (!props.globalStore) {
        return null;
    }
    return (React.createElement(LeftRailHeader_1.LeftRailHeader, tslib_1.__assign({}, props, { videoPageStore: props.globalStore.greenSectionStore.videoPageStore })));
});
